import Vue from 'vue'
import {BallPulseLoader} from 'vue-loaders';
import VueSimpleSpinner from 'vue-simple-spinner'
import HttpMixin from '@/mixins/HttpMixin';
import {InvoiceChecklistItem} from '@/interfaces/invoice';

export default Vue.component('invoice-checklist-card', {
  name: 'InvoiceChecklistCard',
  props: {
    'facilityId': { type: String },
    'specialtyId': { type: String },
    'invoiceStartDate': { type: String },
    'invoiceId': { type: [String, Number] },
    'mergedInvoiceId': { type: [String, Number] }
  },
  data () {
    return {
      cardExpanded: false,
      checklistItems: [] as InvoiceChecklistItem[]
    }
  },
  components: {
    BallPulseLoader,
    VueSimpleSpinner
  },
  mixins: [ HttpMixin ],
  computed: {
    remainingCount(): number {
      return this.checklistItems.map(item => item.isChecked ? 0 : 1).reduce((a: number, b: number) => a + b, 0);
    },
    url(): string {
      if (Number(this.invoiceId) > 0) {
        return `/invoices/checklist-items?invoiceId=${this.invoiceId}`;
      } else if (this.mergedInvoiceId) {
        return `/invoices/checklist-items?mergedInvoiceId=${this.mergedInvoiceId}`;
      } else {
        return `/invoices/checklist-items?facilityId=${this.facilityId}&specialtyId=${this.specialtyId}&invoiceDate=${this.invoiceStartDate}`;
      }
    }
  },
  async created() {
    await this.expandCard();
  },
  methods: {
    async expandCard () {
      this.cardExpanded = !this.cardExpanded;
      if (this.cardExpanded) {
        await this.getChecklistItems();
      }
    },
    async getChecklistItems() {
      this.checklistItems = await (this as any).httpGet(this.url, 'Error retrieving Checklist Items') || [];
    },
    async toggle(item: InvoiceChecklistItem) {
      const results = await (this as any).httpPut(`/invoices/checklist-items/${item.invoiceChecklistId}`, 'Error updating Checklist Items', item, true, false);
      if (!results) {
        // An error occurred, undo
        item.isChecked = !item.isChecked;
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/components/invoice/cards/checklist/InvoiceChecklistCard.ts